// extracted by mini-css-extract-plugin
export default {"budgetRecap":"budgetRecap_d9ceb"};